module.exports = __webpack_public_path__ + "static/media/player2.8a246baf.png";